import React from 'react';
import { useTranslation } from 'react-i18next';
import './_styles_/AuctionResult.css';
import { auctionType as auctionTypeRef } from '../../types';
import {
    BUY,
    getAuctionType,
} from '../../utils/AuctionTypes';
import ReadonlyNumberField from '../fields/ReadonlyNumberField';
import Collapsible from '../Collapsible';

AuctionResult.propTypes = {
    auction: auctionTypeRef.isRequired,
};

function AuctionResult(props) {
    const {
        auction,
    } = props;
    const { t } = useTranslation();
    const currencyCode = auction.zone.currency.code;
    const auctionType = getAuctionType(auction.auctionType);
    const { auctionResult } = auction;
    const isTabVisible = auctionResult.averageAcceptedPrice !== null
        || auctionResult.lastAcceptedPrice !== null
        || auctionResult.numberOfValidBids !== null
        || auctionResult.indicativePrice !== null
        || auctionResult.isUndersell !== null
        || auctionResult.totalBidQuantities !== null
        || auctionResult.finalPrice !== null
        || auctionResult.totalVolume !== null;
    return (
        isTabVisible && (
            <Collapsible
                header={<h5>{t('auctions.auction-setup.auction-result')}</h5>}
                className="auction-result-container"
                isExpandedOnLoad
            >
                <div className="auction-result">
                    {(auctionResult.finalPrice !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.final-price')}
                            value={auctionResult.finalPrice}
                            postfix={` ${currencyCode}`}
                            fractionDigits={2}
                            className="auction-result--final-price"
                        />
                    )}
                    {(auctionResult.indicativePrice !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.indicative-price')}
                            value={auctionResult.indicativePrice}
                            postfix={` ${currencyCode}`}
                            fractionDigits={2}
                            className={`auction-result--indicative-price ${auctionType.resolveIndicativePriceClass(auctionResult.indicativePrice, auction)}`}
                        />
                    )}
                    {(auctionResult.averageAcceptedPrice !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.average-accepted-price')}
                            value={auctionResult.averageAcceptedPrice}
                            emptyValue={t('auctions.auction-setup.no-average-accepted-price')}
                            postfix={` ${currencyCode}`}
                            fractionDigits={2}
                            className="auction-result--average-accepted-price"
                        />
                    )}
                    {(auctionResult.lastAcceptedPrice !== null) && (
                        <ReadonlyNumberField
                            label={
                                auctionType.is(BUY)
                                    ? t('auctions.auction-setup.minimum-accepted-price')
                                    : t('auctions.auction-setup.maximum-accepted-price')
                            }
                            value={auctionResult.lastAcceptedPrice}
                            emptyValue={
                                auctionType.is(BUY)
                                    ? t('auctions.auction-setup.no-minimum-accepted-price')
                                    : t('auctions.auction-setup.no-maximum-accepted-price')
                            }
                            postfix={` ${currencyCode}`}
                            fractionDigits={2}
                            className="auction-result--last-accepted-price"
                        />
                    )}
                    {(auctionResult.numberOfValidBids !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.number-of-valid-bids')}
                            value={auctionResult.numberOfValidBids}
                            className="auction-result--number-of-valid-bids"
                        />
                    )}
                    {(auctionResult.isUndersell !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.undersell')}
                            value={auctionResult.isUndersell ? t('misc.yes') : t('misc.no')}
                            className="auction-result--undersell"
                        />
                    )}
                    {(auctionResult.totalBidQuantities !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.total-bids-quantities')}
                            value={auctionResult.totalBidQuantities}
                            className="auction-result--total-bids-quantities"
                        />
                    )}
                    {(auctionResult.totalVolume !== null) && (
                        <ReadonlyNumberField
                            label={t('auctions.auction-setup.total-value-of-accepted-bids')}
                            value={auctionResult.totalVolume}
                            postfix={` ${currencyCode}`}
                            fractionDigits={2}
                            className="auction-result--total-value-of-accepted-bids"
                        />
                    )}
                </div>
            </Collapsible>
        )
    );
}

export default AuctionResult;
